(function () {
  var MAP = {
    'Price': 'מחיר',
    'Availability': 'זמינות',
    'In stock': 'במלאי',
    'Out of stock': 'אזל מהמלאי',
    'Featured': 'רלוונטי ביותר',
    'Best selling': 'נמכר ביותר'
  };
  var SELECTOR = '.facets__label, .facets__pill-label, .sorting-filter__label, .facets select option, select[name="sort_by"] option';

  function translateNode(el) {
    if (!el || el.nodeType !== 1) return;
    if (el.tagName === 'OPTION') {
      var t = (el.textContent || '').trim();
      if (MAP[t]) el.textContent = MAP[t];
      return;
    }
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType === 3) {
        var trimmed = node.nodeValue.trim();
        if (MAP[trimmed]) {
          node.nodeValue = node.nodeValue.replace(trimmed, MAP[trimmed]);
        }
      }
    }
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.querySelectorAll) {
      var list = root.querySelectorAll(SELECTOR);
      for (var i = 0; i < list.length; i++) translateNode(list[i]);
    }
    if (root.matches && root.matches(SELECTOR)) translateNode(root);
  }

  function run() {
    scan(document.documentElement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) scan(added[j]);
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
